Immutable = require 'seamless-immutable'
{ did, doing } = require './common'
{ CREATED_USER, CREATING_USER, DELETED_USER, DELETING_USER, FETCHED_USERS, FETCHING_USERS, UPDATED_USER, UPDATING_USER } = require '../actions/users'

baseState = Immutable {
	list: []
	isCreating: false
	isDeleting: false
	isFetching: false
	isUpdating: false
}

users = (state = baseState, action) ->
	switch action.type
		when CREATING_USER
			state = doing 'isCreating', state
		when CREATED_USER
			state = did 'isCreating', state, action
		when DELETING_USER
			state = doing 'isDeleting', state
		when DELETED_USER
			state = did 'isDeleting', state, action
		when FETCHING_USERS
			state = doing 'isFetching', state
		when FETCHED_USERS
			state = did 'isFetching', state, action
		when UPDATING_USER
			state = doing 'isUpdating', state
		when UPDATED_USER
			state = did 'isUpdating', state, action
	state

module.exports = users



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/users.coffee